<template>
    <v-card class="rounded-xl card-title-footer-color mx-0 px-0">
        <v-card-title class="px-5 pb-0">
            <v-row>
                <v-col cols="4">
                    <v-text-field
                        v-model="search"
                        placeholder="Buscar"
                        color="primary"
                        class="app-text-field-no-border rounded-lg ma-0 pb-3 pt-0 buscador-input"
                        hide-details="auto"
                        height="36px"
                        prepend-inner-icon="mdi-magnify"
                        clearable
                    />
                </v-col>
                <v-col cols="8" class="d-flex justify-end">
                    <hide-deleted-switch v-model="hideDeleted" />
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-text  class="px-0 pt-0 card-title-footer-color">
            <v-data-table
                :items="items"
                :headers="headers"
                :search="search"
                :footer-props="{
                  'items-per-page-options': [5, 10, 100, 1000],
                  'items-per-page-text': 'Empresas por página:',
                }"
            >
                <template #body="{ items, headers }">
                    <tbody>
                        <tr v-for="item in items" :key="item.name">
                            <td 
                                v-for="header in headers" 
                                :key="header.value"
                                class="td__selectable"
                                :style="{opacity:item.deleted?'0.5':'1'}"
                                @click="emitState(item.company_id, header.value)"
                            >
                                {{item[header.value]}}
                            </td>
                            
                        </tr>
                        <tr class="deep-purple lighten-5 font-weight-bold">
                            <td v-for="header in headers" :key="header.value">
                                {{total[header.value]}}
                            </td>
                        </tr>
                    </tbody>
                </template>
                <template v-slot:[`footer.page-text`]="items">
                    {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>     
</template>

<script>
import HideDeletedSwitch from './HideDeletedSwitch.vue';
export default {
    components: {
        HideDeletedSwitch,
    },
    props: {
        dashboardData: {
            type: Array,
            required: false,
            default: function () {
                return [];
            },
        },
        initialHideDeleted: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            search: '',
            hideDeleted: this.initialHideDeleted
        }
    },

    computed:{
        headers() {
            const headers = [
                {value: 'company_name', text: 'Nombre',},
                {value: 'all', text: 'Todos'},
                {value: 'booked_count', text: 'Contabilizados'},
                {value: 'error_count', text: 'Errores'},
                {value: 'deleted_count', text: 'Borrados'},
                {value: 'pending_count', text: 'En proceso'},
                {value: 'booked_deleted_count', text: 'Borr. Cont.'},
                {value: 'pending_sync_count', text: 'Pdte. Sinc.'},
                {value: 'pending_review_count', text: 'Pdte. Revisión'},
                {value: 'accounting_count', text: 'Contabilizando'},
                {value: 'error_accounting_count', text: 'Error Cont.'},
            ]
        

            return headers
        },

        items() {
            let items = []
            this.dashboardData.forEach(element => {
                if(this.hideDeleted && element.deleted){
                    return;
                }
                let item = element
                item['all'] = item['booked_count'] + item['error_count']+ item['deleted_count']+ item['pending_count']+item['pending_review_count']+item['accounting_count']
                items.push(item)
            });
            return items
        },
        total(){
            let total_row = {company_name:'Todos'}
            this.headers.forEach(hdr => {
                    if(hdr.value != 'company_name'){
                        total_row[hdr.value] = 0
                    }
                });
            this.items.forEach(item => {
                this.headers.forEach(hdr => {
                    if(hdr.value != 'company_name'){
                        total_row[hdr.value] += item[hdr.value]
                    }
                });
            });
            return total_row
        },
    },

    watch: {
        hideDeleted() {
            this.$emit('update-hide-deleted', this.hideDeleted);
        },
    },

    methods: {
        emitState(id, state) {
            if (state !== 'company_name') {
                this.$emit('click-dashboard-state', {id, state})
            }
        },
    }
};
</script>

<style scoped>
    .row-head {
        overflow: hidden;
        position: relative;
        height: 100%;
    }
    .buttom-border {
        border-bottom-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-head{
        border-left-style:solid;
        border-right-style:solid;
        /* border-bottom-style:solid; */
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-row{
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;  
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-name {
        border-left-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }

    .card-title-footer-color {
        background: #FAFAFF;
    }
    ::v-deep .v-data-footer {
        background-color: #FAFAFF;
        margin-right: 0px !important;
        padding-right:  17px;
    }
    ::v-deep .v-data-table-header > tr > th{
        background-color: var(--v-primaryLight-base) !important;
    }
    ::v-deep .v-data-table-header > tr > th > span{
        color: var(--v-primary-base);
        font-size: 0.875rem;
    }
    .font-color {
        color: #56565B;
    }

    ::v-deep .v-data-table__wrapper > table > tbody > tr > td {
        border-bottom: none !important;
    }

    ::v-deep tbody tr:nth-of-type(even) {
        /* 'deep-orange lighten-5' basides on material design color */
        background-color: rgba(245, 245, 245, 0.47);
    }

    ::v-deep .v-input__prepend-inner > div > i {
        color: var(--v-primary-base);
        top: 2px;
        padding-left: 5px;
    }

    .buscador-input {
        font-weight: normal;
        font-size: 0.875rem;
    }

    .td__selectable {
        cursor: pointer;
    }

    .td__selectable:hover {
        background-color: rgba(102, 51, 153, 0.1);
    }
</style>